export const environment = {
    baseUrl: '',
    controlManualUrl: 'https://ext-dev.brunata.com/extranet-control-manual/',
    env: 'development',
    host: 'https://online-dev.brunata.com',
    minEnergi2SSOUrl: 'https://ems.enity.io/brunata/sso',
    enityEmsUrl: 'https://brunata.test-ems.enity.io',
    oauthClientId: '549e1849-ad1c-4ad7-8f2f-7a32f7369131',
    oauthUrl: 'https://online-dev.brunata.com/online-auth-webservice/v1/rest',
    keycloakResetPasswordUrl:
        'https://online.brunata.com/iam/realms/online-dev/login-actions/reset-credentials',
    brunataEnvironment: 'dev',
    tracingEndpoint: 'https://online.brunata.com/otel/api/v2/spans',
    onlineServiceUrl: '/online-webservice/v2/rest',
    production: false,
    reactOnlineUrl: 'https://online-dev.brunata.com/react-online',
    selfServiceUrl: '/online-reporting-webservice/rest',
    visualUrl: 'https://online-dev.brunata.com/visual/',
    webArchiveServiceUrl: '/webarchive-webservice/rest',
    featureFlagsUrl: 'https://webbill-dev.brunata.dk/webbill-webservice/featureflags',
    webmonIframeUrl: 'https://online-dev.brunata.com',
    rollbarToken: '0b684a6a0e4e4a6cbf52055c3e821497',
    rollbarEnabled: false,
};
